import { render, staticRenderFns } from "./RejectedReservationExtensions.vue?vue&type=template&id=b6c6f7ee&scoped=true&"
import script from "./RejectedReservationExtensions.vue?vue&type=script&lang=js&"
export * from "./RejectedReservationExtensions.vue?vue&type=script&lang=js&"
import style0 from "./RejectedReservationExtensions.vue?vue&type=style&index=0&id=b6c6f7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c6f7ee",
  null
  
)

export default component.exports